export const htmlTagsRegex = /(<([^>]+)>)/ig;